import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@app/store';
import { getIndicatorState } from '@app/store/globals';

/* *********************** *
 *    Type definitions     *
 * *********************** */
export interface IndicatorState {
  isLoadingDopLayer: boolean;
  isLoadingSatCountLayer: boolean;
  isLoadingSatelliteLayer: boolean;
}

/* ************************* *
 *    Utitilty functions     *
 * ************************* */

/* ********************* *
 *    Slice creation     *
 * ********************* */
const initialState: IndicatorState = {
  isLoadingDopLayer: false,
  isLoadingSatCountLayer: false,
  isLoadingSatelliteLayer: false,
};

const indicatorSlice = createSlice({
  name: 'indicator',
  initialState,
  reducers: {
    setIsLoadingDopLayer: (state: IndicatorState, action: PayloadAction<boolean>) => {
      state.isLoadingDopLayer = action.payload;
    },
    setIsLoadingSatCountLayer: (state: IndicatorState, action: PayloadAction<boolean>) => {
      state.isLoadingSatCountLayer = action.payload;
    },
    setIsLoadingSatelliteLayer: (state: IndicatorState, action: PayloadAction<boolean>) => {
      state.isLoadingSatelliteLayer = action.payload;
    },
  },
});

/* *********************** *
 *    Export selectors     *
 * *********************** */
export const getIsLoadingDopLayer = (state: RootState) =>
  getIndicatorState(state).isLoadingDopLayer;
export const getIsLoadingSatCountLayer = (state: RootState) =>
  getIndicatorState(state).isLoadingSatCountLayer;
export const getIsLoadingSatelliteLayer = (state: RootState) =>
  getIndicatorState(state).isLoadingSatelliteLayer;

/* ********************* *
 *    Export actions     *
 * ********************* */
export const { setIsLoadingDopLayer, setIsLoadingSatCountLayer, setIsLoadingSatelliteLayer } =
  indicatorSlice.actions;

/* ********************* *
 *    Export reducer     *
 * ********************* */
export default indicatorSlice.reducer;
